import { render } from "./HeadingTwo.vue?vue&type=template&id=6a7bbd90&scoped=true"
import script from "./HeadingTwo.vue?vue&type=script&lang=js"
export * from "./HeadingTwo.vue?vue&type=script&lang=js"

import "./HeadingTwo.vue?vue&type=style&index=0&id=6a7bbd90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7bbd90"]])

export default __exports__